import * as React from "react";
import styled from "styled-components";
import { Color } from "../../constants/legacy";

type Props = {
  isLoading: boolean;
  label?: string;
};

export default function SubmitButton({ isLoading, label }: Props) {
  return (
    <StyledButton type="submit" disabled={isLoading}>
      {label || "Submit"}
    </StyledButton>
  );
}

/**
 * Would be nice to use <Button /> but that's more for either <a> or <Link>
 */
const StyledButton = styled.button`
  cursor: pointer;
  background-color: ${Color.cyan};
  height: 62px;
  font-size: 18px;
  font-weight: 600;
  color: ${Color.darkBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  transition: all 0.25s;

  &:hover {
    background-color: ${Color.cyanHover};
  }

  &[disabled] {
    cursor: default;
    &:hover {
      background-color: ${Color.cyan};
    }
  }
`;
